import { render, staticRenderFns } from "./MSOGroupBase.vue?vue&type=template&id=bd9d49f8&"
import script from "./MSOGroupBase.vue?vue&type=script&lang=js&"
export * from "./MSOGroupBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports